/** Read-time words for the stored `convergence_status` code. Display only. */
export function convergenceLabel(status: string | null | undefined): string {
  if (!status) return ''
  if (status.startsWith('converged')) return 'Approaches agree'
  if (status.startsWith('divergent')) return 'Approaches differ — a Valuation Signer must review'
  if (status.startsWith('n/a')) return 'Not applicable'
  return status
}
